/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { errorHandler } from '@/app/shared/services/error-handler.js';

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // /////////////////////////////////////////////
  // Projects
  // /////////////////////////////////////////////
  fetchAllAuthorizedProjects({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("Core/Projects/findAllAuthorized")
        .then((response) => {
          commit('SET_AUTHORIZED_PROJECTS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },

  updateProjectId({ commit }, val) {
    commit('UPDATE_PROJECT', val)
  },

  // /////////////////////////////////////////////
  // Projects
  // /////////////////////////////////////////////
  fetchConfigurations({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("Core/FrontendConfigurations/Find")
        .then((response) => {
          commit('SET_CONFIGURATIONS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  appBootstrapCompleted({ commit }) {
    commit('SET_APP_BOOTSTRAP_COMPLETED', true)
  }
}

export default actions
